import React, { useState } from "react";
import EditFieldModal from "../Edit Field Modal/EditFieldModal";
import { FaSearch } from "react-icons/fa";
import ConfirmationPopup from "./Conformation Popup/ConformarionPopup";

const SellerDetailsForm = ({ message }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingFieldKey, setEditingFieldKey] = useState(null);

  const [fields, setFields] = useState({
    email: {
      label: "Email",
      placeholder: "Enter your Email Address",
      type: "required",
    },
    mobile: {
      label: "Mobile",
      placeholder: "Enter Mobile Number",
      type: "required",
    },
    status: {
      label: "Seller Status",
      placeholder: "Status",
      type: "required",
      options: ["Select", "Active", "On Hold", "Premium", "Deactive"],
    },
    subscription: {
      label: "Present Subscription",
      placeholder: "Select Present Subscription",
      type: "required",
      options: ["Select", "Per Per Contact", "Monthly 50", "Yearly 500"],
    },
  });

  const [addFieldModalOpen, setAddFieldModalOpen] = useState(false);
  const [sellerDetailModalOpen, setSellerDetailModalOpen] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = useState("");
  const [openStatusPopup, setOpenStatusPopup] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [dropdownType, setDropdownType] = useState("");
  const [newFieldDetails, setNewFieldDetails] = useState({
    label: "",
    placeholder: "",
    type: "required",
    options: "",
  });

  const handleshowConfirmPopup = (opt) => {
    setOpenStatusPopup(true);
    setStatusMessage(opt);
  };

  const handleEditClick = (key) => {
    setEditingFieldKey(key);
    setIsModalOpen(true);
  };

  const handleSaveField = (updatedField) => {
    setFields((prev) => ({
      ...prev,
      [editingFieldKey]: updatedField,
    }));
    setIsModalOpen(false);
  };

  const handleAddNewField = () => {
    if (!newFieldDetails.label || !newFieldDetails.placeholder) {
      alert("Please fill in all required fields");
      return;
    }

    const key = newFieldDetails.label.toLowerCase().replace(/\s+/g, "_");

    const newField = {
      label: newFieldDetails.label,
      placeholder: newFieldDetails.placeholder,
      type: newFieldDetails.type,
    };

    if (["Drop Down", "Radio", "Check Box"].includes(selectedFieldType)) {
      newField.options = newFieldDetails.options
        .split(",")
        .map((opt) => opt.trim())
        .filter(Boolean);
    }

    setFields((prev) => ({
      ...prev,
      [key]: newField,
    }));

    setNewFieldDetails({
      label: "",
      placeholder: "",
      type: "required",
      options: "",
    });
    setSelectedFieldType("");
    setSellerDetailModalOpen(false);
  };

  return (
    <div className="p-6 bg-white border-2 border-gray-300 my-5 mx-10 rounded-lg shadow-md w-[72vw]">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-800 underline">
          Seller Details :
        </h2>
      </div>

      <div className="grid grid-cols-2 gap-8">
        {Object.entries(fields).map(([key, field]) => (
          <div key={key} className="flex flex-col">
            <div className="flex items-center justify-between">
              <label className="text-md font-semibold text-gray-500">
                {field.label}
                <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center gap-5">
                {message === "actions not show" ? (
                  <></>
                ) : (
                  <>
                    <span
                      onClick={() => handleEditClick(key)}
                      className="text-gray-400 cursor-pointer"
                    >
                      ✎
                    </span>
                    <span className="text-gray-400 cursor-pointer scale-150">
                      x
                    </span>
                  </>
                )}
              </div>
            </div>

            {field.options ? (
              <select
                onChange={(e) => {
                  handleshowConfirmPopup(e.target.value);
                  setDropdownType(field.label.toLocaleLowerCase());
                }}
                value={selectedStatus}
                className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 outline-none"
              >
                {field.options.map((opt, index) => (
                  <option key={index} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                placeholder={field.placeholder}
                className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 outline-none"
              />
            )}
          </div>
        ))}
      </div>

      {/* Add Field Modal */}
      {addFieldModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white w-full h-fit max-w-2xl rounded-lg shadow-lg p-6">
            <div className="flex items-center justify-between mb-5">
              <h1 className="text-xl text-gray-900 font-bold">Add Field</h1>
              <h1
                onClick={() => setAddFieldModalOpen(false)}
                className="text-xl text-gray-900 hover:text-red-600 cursor-pointer font-bold"
              >
                X
              </h1>
            </div>

            <div className="relative">
              <input
                type="text"
                placeholder="Search ..."
                className="w-full border p-2 mb-4 border-gray-300 rounded-md bg-gray-200 text-gray-500 outline-none"
              />
              <FaSearch className="absolute right-3 top-3 text-gray-500" />
            </div>

            <h1 className="text-gray-900 underline text-lg my-5">
              Field Types:
            </h1>

            <div className="grid grid-cols-2 gap-3 px-10 mb-5">
              {[
                "Text fields",
                "Radio",
                "Date",
                "Drop Down",
                "Slider",
                "Check Box",
                "Attachment",
              ].map((fieldType) => (
                <label
                  key={fieldType}
                  className="flex items-center text-lg gap-2"
                >
                  <input
                    type="radio"
                    value={fieldType}
                    onChange={() => setSelectedFieldType(fieldType)}
                    checked={selectedFieldType === fieldType}
                  />
                  {fieldType}
                </label>
              ))}
            </div>

            <div className="flex justify-end gap-2 border-t border-gray-300 pt-5">
              <button
                onClick={() => setAddFieldModalOpen(false)}
                className="px-4 py-1 bg-gray-300 rounded"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (selectedFieldType) {
                    setAddFieldModalOpen(false);
                    setSellerDetailModalOpen(true);
                  } else {
                    alert("Please select a field type");
                  }
                }}
                className="px-4 py-1 bg-blue-600 text-white rounded"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Seller Detail Modal */}
      {sellerDetailModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white w-full h-[70vh] max-w-xl rounded-lg shadow-lg p-6 overflow-auto">
            <div className="flex items-center justify-between mb-5">
              <h1 className="text-xl text-gray-900 font-bold">
                Security Details
              </h1>
              <h1
                onClick={() => setSellerDetailModalOpen(false)}
                className="text-xl text-gray-900 hover:text-red-600 cursor-pointer font-bold"
              >
                X
              </h1>
            </div>

            <div className="mb-3 flex items-center justify-between gap-5">
              <div className="flex-1">
                <label className="block text-gray-600 mb-3">
                  Label<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter label name"
                  className="w-full border border-gray-300 p-2 rounded"
                  value={newFieldDetails.label}
                  onChange={(e) =>
                    setNewFieldDetails({
                      ...newFieldDetails,
                      label: e.target.value,
                    })
                  }
                />
              </div>
              <div className="flex-2">
                <label className="block text-gray-600 mb-3">
                  Type<span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border border-gray-300 p-2 rounded"
                  value={newFieldDetails.type}
                  onChange={(e) =>
                    setNewFieldDetails({
                      ...newFieldDetails,
                      type: e.target.value,
                    })
                  }
                >
                  <option>Select</option>
                  <option>required</option>
                  <option>non-required</option>
                </select>
              </div>
            </div>

            <div className="mb-3">
              <label className="block text-gray-600 mb-3">
                Placeholder<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter placeholder"
                className="w-full border border-gray-300 p-2 rounded"
                value={newFieldDetails.placeholder}
                onChange={(e) =>
                  setNewFieldDetails({
                    ...newFieldDetails,
                    placeholder: e.target.value,
                  })
                }
              />
            </div>

            {(selectedFieldType === "Drop Down" ||
              selectedFieldType === "Radio" ||
              selectedFieldType === "Check Box") && (
              <div className="mb-3">
                <label className="block text-gray-600 mb-3">
                  Options<span className="text-red-500">*</span>
                </label>
                <textarea
                  placeholder="Enter options separated by commas ( , )"
                  className="w-full h-36 border border-gray-300 p-2 rounded"
                  value={newFieldDetails.options}
                  onChange={(e) =>
                    setNewFieldDetails({
                      ...newFieldDetails,
                      options: e.target.value,
                    })
                  }
                />
              </div>
            )}

            <div className="flex justify-end gap-2">
              <button
                onClick={handleAddNewField}
                className="px-4 py-1 bg-blue-600 text-white rounded"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 items-center px-10 mt-6">
        <div className="flex items-center justify-end">
          <button
            onClick={() => setAddFieldModalOpen(true)}
            className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
          >
            Add Field
          </button>
        </div>
        <div className="flex items-center justify-end">
          <button
            onClick={() => setAddFieldModalOpen(true)}
            className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
          >
            Add Field
          </button>
        </div>
      </div>

      {/* Edit Field Modal */}
      <EditFieldModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fieldData={editingFieldKey ? fields[editingFieldKey] : {}}
        onSave={handleSaveField}
        content={"Seller Details"}
      />

      {openStatusPopup && (
        <ConfirmationPopup
          message={`Are you sure you want to change the "${dropdownType}" to "${statusMessage}"?`}
          onCancel={() => {
            setOpenStatusPopup(false);
            setSelectedStatus("Select");
          }}
          onConfirm={() => {
            setSelectedStatus(statusMessage);
            setOpenStatusPopup(false);
          }}
        />
      )}
    </div>
  );
};

export default SellerDetailsForm;
